export const SET_CUSTOMERS = "setCustomers";
export const CLEAR_CUSTOMERS = "clearCustomers";
export const SET_TOTAL_CUSTOMERS = "setTotalCustomers";
export const CLEAR_TOTAL_CUSTOMERS = "clearTotalCustomers";
export const REMOVE_CUSTOMER = "removeCustomer";
export const SET_NOTES = "setNotes";
export const CLEAR_NOTES = "clearNotes";
export const ADD_NOTE = "addNote";
export const REMOVE_NOTE = "removeNote";
export const SET_CUSTOMER_METADATAS = "setCustomerMetadatas";
export const CLEAR_CUSTOMER_METADATAS = "clearCustomerMetadatas";
